import {i18n} from '@/helpers/translations';

export interface ITranslatedField {
  [key: string]: string,
}

export class TranslationHelper {

  public static PRIORITY_LANGUAGES: string[] = [
    'en-GB',
    'es-ES',
  ];

  public static translateField(f: ITranslatedField, preferredLanguages: string[] = []): string {
    const languagesToTry: string[] = [
      ...preferredLanguages,
      i18n.t('locale').toString()
    ]
      .concat((i18n.t('localeFallbacks')) as any)
      .concat(Object.keys(f));
    for (let i in Object.keys(languagesToTry)) {
      const l = languagesToTry[i];
      if (f.hasOwnProperty(l) && f[l].length) {
        return f[l];
      }
    }
    return '???';
  }

}
